import { createContext, PropsWithChildren, useContext, useState } from 'react';

const initialData = {
  expanded: false,
  toggle: () => {},
};

const AccordionContext = createContext(initialData);

export default function AccordionProvider({
  children,
  initialValue,
}: PropsWithChildren<{ initialValue: boolean }>) {
  const [expanded, setExpanded] = useState(initialValue);

  function toggle() {
    setExpanded(!expanded);
  }

  return (
    <AccordionContext.Provider value={{ expanded, toggle }}>
      <div
        style={{
          backgroundColor: expanded ? '#F5F5F5' : 'transparent',
          padding: expanded ? '20px' : '0px 20px 0px 0px',
        }}
      >
        {children}
      </div>
    </AccordionContext.Provider>
  );
}

export const useAccordion = () => {
  const { expanded, toggle } = useContext(AccordionContext);

  return { expanded, toggle };
};
